<span class="{{class}}" [style.border]=border [style.background-color]=backgroundColor>
  {{rating}}
  <mat-icon svgIcon="star" class="icon-size-12"></mat-icon>
</span>
